<template>
  <ul id="p-tabs" class="nav d-md-none d-flex">
    <router-link
      class="nav-link"
      :to="routerHandler(1)"
      :class="{ 'router-link-active': $route.path.search('phase1') > 0 }"
      >國內研習營</router-link
    >
    <router-link
      class="nav-link"
      :to="routerHandler(2)"
      :class="{ 'router-link-active': $route.path.search('phase2') > 0 }"
      >國內研習排序</router-link
    >
    <router-link
      class="nav-link"
      :to="routerHandler(3)"
      :class="{ 'router-link-active': $route.path.search('phase3') > 0 }"
      >國內複審名單</router-link
    >
    <router-link
      class="nav-link"
      :to="routerHandler(4)"
      :class="{ 'router-link-active': $route.path.search('phase4') > 0 }"
      >海外培訓名單</router-link
    >
  </ul>
</template>
<script>
export default {
  methods: {
    routerHandler(n) {
      const rGroup = this.$route.params.groupId;
      return { path: `/camp-lists/phase${n}/${rGroup}` };
    },
  },
};
</script>

<style lang="stylus">
#p-tabs
  white-space: nowrap;
  width: 100%;
  border-bottom: 1px solid $monoc4;

/* Hide scrollbar for Chrome, Safari and Opera */
#p-tabs::-webkit-scrollbar
  display: none;

/* Hide scrollbar for IE, Edge and Firefox */
#p-tabs
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
  color: $monoc4;

  li
    width: 30vw;

  .nav-link
    display: inline-block;
    padding: 14px 0;
    text-align: center;
    margin: 0 auto;
    font-size: 14px;
    font-weight: 700;
    line-height: 150%;
    color: $monoc1;
    letter-spacing: 0;
    color: $monoc4;
    opacity: 0.2;

    &:hover, &:focus
      opacity: 1;

  .nav-link.router-link-active
    background-color: $monoc1;
    color: $monoc4;
    opacity: 1;
</style>
